<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import {
		get_gen_2_control_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Stores
		//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Alert, Toggle, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	let settings = $settingsStore;
	const settingsKey = get_gen_2_control_component_channel_structure(device);

	let isLocked = settings?.[settingsKey]?.in_locked;
	let cache = isLocked;

	const sentRequests = async () => {
		const newValueInvert = !isLocked;
		if (cache === newValueInvert) return;
		const params = {
			id: device.channel,
			config: { in_locked: newValueInvert },
		};

		const res: SettingRequest = await gen2Request(
			device,
			`${get_gen_2_component_from_category(device)}.SetConfig`,
			params,
		);

		if (res.isok) {
			isLocked = newValueInvert;
			settings[settingsKey].in_locked = isLocked;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
			cache = isLocked;
		} else {
			toast.open({
				type: 'danger',
				title: $format('toast_title_failed_lock_inputs', {
					default: 'Failed to change the lock inputs state',
				}),
			});
			isLocked = cache;
		}
	};
</script>

<Toggle class="mb-s" checked={isLocked} size="m" on:click={sentRequests} id="toggle-465ghf">
	{capFirstChar(
		$format('enable', {
			default: 'Enable',
		}),
	)}
</Toggle>

<Alert
	type="info"
	heading={$format('alert_info_heading_lock_inputs', {
		default: 'When locked, all changes to physical inputs are ignored, regardless of mode.',
	})}
/>
